export default {"src":"/_next/static/media/home-3.74d93cfa.svg","height":1386,"width":1440};